import React from "react";
import "../components/App.css";
import { Container } from "@mui/material";

const Shop = () => {
  return (
    <Container>
      <div className="shop-container">
        <h3 style={{ marginBottom: "3rem", textAlign: "center" }}>
          Exclusive online store only for Our Users
        </h3>
        <p style={{ fontSize: "18px" }}>
          Now our subscribers can shop at our online store
        </p>
        <ul>
          <li>Heavy Discounts</li>
          <li>24X7 Access</li>
          <li>Within 8 hour delivery</li>
          <li>Payment On Delivery</li>
          <li>EMI Option</li>
          <li>No minimum cart value</li>
          <li>Major Brands Listed</li>
          <li>Top Quality Products</li>
          <li>Choice to choose between multiple range</li>
          <li>Return Freedom</li>
          <li>Cash backs on your purchases</li>
          <li>And more benefits to avail</li>
        </ul>
      </div>
    </Container>
  );
};

export default Shop;
